import React from "react";

export const TrackingRouter = ({ children }) => {
  return (
    <main>
      {children}
    </main>
  );
};
